import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";

export function useShowCCModal() {
  const { state, setState } = useManageMyGivingPage();
  const showCCModal = state.showCCModal;

  const setShowCCModal = (show) => {
    setState({ showCCModal: show });
  };

  return [showCCModal, setShowCCModal];
}
